<template>
  <div class="grid-content">
    <div class="loading" v-loading="loading">
      <el-form
        ref="giftBalanceSetting"
        label-width="120px"
        label-position="left"
      >
        <div>
          <div>
            <el-button
              v-if="!options.isReadonly"
              size="medium"
              type="text"
              icon="el-icon-plus"
              @click="onAdd()"
              >添加余额充值优惠</el-button
            >
          </div>
        </div>
        <el-row
          v-for="(item, index) in giftBalanceList"
          :key="index"
        >
          <el-col :span="6">
            <el-form-item
              label="名称"
            >
              <el-input v-model="item.Name" class="input-width" size="small" :maxlength="250" :disabled="options.isReadonly">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="6">
            <el-form-item
              label="充值金额"
            >
              <el-input-number v-model="item.IncreasedAmount" size="small" class="input-width" controls-position="right" :min="0" :max="100000" :disabled="options.isReadonly">
                <template slot="append"> $ </template>
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="1"> </el-col>
          <el-col :span="6">
            <el-form-item label="赠送金额">
               <el-input-number v-model="item.GiftAmount" size="small" class="input-width" controls-position="right" :min="0" :max="100000" :disabled="options.isReadonly">
                <template slot="append"> $ </template>
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="2" v-if="!options.isReadonly">
            <el-button
              size="small"
              v-if="item.Enable"
              @click="item.Enable = !item.Enable"
              type="danger"
              class="enableButton"
              >停用</el-button
            >
            <el-button
              size="small"
              v-if="!item.Enable"
              @click="item.Enable = !item.Enable"
              type="primary"
              class="enableButton"
              >启用</el-button
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <hr />
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row v-if="!options.isReadonly" class="cs-filter-row">
      <el-col :span="4" class="footer-left">
        <el-button
          size="medium"
          :disabled="submitBtnDisable"
          :type="submitBtnClass"
          @click="onSave"
          >保存更新</el-button
        >
      </el-col>
      <el-col :span="16" class="footer-right">
        <el-alert
          :closable="false"
          v-show="showError"
          v-bind:title="errorMessage"
          type="error"
          show-icon
        ></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    overflow: visible;
    white-space: nowrap;
    padding-right: 10px;
  }

  .el-input {
    text-align-last: center;
    min-width: 120px;
    width: 50%;
    &.ca-adPrice-comment {
      width: 70%;
    }
  }

  .enableButton {
    margin-left: 20px;
    margin-top: 5px;
  }
  .el-form-item {
    margin-left: 10px;
  }
}
</style>

<script>
import {
  saveGiftBalances,
  getGiftBalances,
} from "../../service/otherCollectFee.service";

export default {
  props: {
    isActive: Boolean,
    options: {
      isReadonly: Boolean,
    },
  },
  data() {
    return {
      isLoadedData: false,
      loading: false,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      showError: false,
      errorMessage: "",
      giftBalanceList:[]
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadGiftBalances();
  },
  updated() {

  },
  methods: {
    loadGiftBalances(){
      if (!this.isActive){
        return;
      }

      this.loading = true;
      getGiftBalances(false, true).then(result =>{
        if (result && result.success){
          this.giftBalanceList = result.data;
        }
        this.loading = false;
        this.isLoadedData = true;
      });
    },
    onSave() {
      let msg = "";
      for(let i = 0; i < this.giftBalanceList.length; i++){
        let item = this.giftBalanceList[i];
        if (item.IncreasedAmount == 0){
          msg += (i + 1).toString() + ", ";
        }
      }
      if (msg.length > 0){
        msg = "行" + msg.substring(0, msg.length - 2) + "的充值金额不能为0";
        this.errorMessage = msg;
        this.showError = true;
        return;
      }
      this.showError = false;
      this.loading = true;
      saveGiftBalances(this.giftBalanceList).then(result => {
        if (!!result && result.success){
          this.$message.success("保存成功！");
        }
        this.loading = false;
      }).catch(e =>{
        this.loading = false;
      });
    },
    onAdd(){
      let model = {
        Id : 0,
        IncreasedAmount: 0,
        Name: "",
        GiftAmount:0,
        Enable: true
      };
      this.giftBalanceList.push(model);
    },

  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
          this.loadGiftBalances();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/giftBalance.vue